import axios from "axios";
import { getAccessToken, clearAuth } from "../utils/authToken";

export const API_BASE = "https://davidfosteracademy.org/backend";

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Normalize error message for UI; redirect to sign-in on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    error.userMessage =
      (typeof data?.message === "string" && data.message) ||
      data?.error ||
      error.message;
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes("/admin/signin")) {
        clearAuth();
        window.location.href = `${process.env.PUBLIC_URL || ''}/admin/signin`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
